module.exports = __webpack_public_path__ + "static/MAP-0267998555ab8fa1352f573197f83e28.png";